import { PAGINATION_RECORD_PER_PAGE, RICH_TEXT_EDITOR_MAX_LENGTH } from "MainApp/features/App/constants";

export const POST_COMMENTS_PER_PAGE = PAGINATION_RECORD_PER_PAGE;
export const POST_COMMENT_LIKED_USERS_PER_PAGE = PAGINATION_RECORD_PER_PAGE;
export const COMMENT_MAX_LENGTH = RICH_TEXT_EDITOR_MAX_LENGTH;